import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b8ae74"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "d-flex flex-col" }
const _hoisted_3 = { class: "banner-overlay d-flex flex-col font-style-dark m-t-48" }
const _hoisted_4 = { class: "d-flex flex-col align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header-text text-center" }, "See A Doctor Now For Free", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center m-0" }, " Skip the waiting room and get the answers you need from qualified healthcare professionals right now, for free. ", -1))
const _hoisted_7 = { class: "signup-form-row d-flex flex-row justify-content-start" }
const _hoisted_8 = { class: "telehealth-image-container m-r-32" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Go to Login ")
const _hoisted_11 = { class: "body-trailer d-flex flex-col align-items-center p-l-16 p-r-16" }
const _hoisted_12 = { class: "featured-container d-flex flex-col align-items-center p-t-64" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "flex-item-fill-row text-center m-0" }, "100,000 patients and counting use CloudMD", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "flex-item-fill-row text-center m-0 p-t-16" }, "We've been featured in:", -1))
const _hoisted_15 = { class: "flex-item-fill-row d-flex flex-col align-items-center p-t-48 p-b-48" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "how-it-works-container d-flex flex-row flex-wrap-reverse justify-content-center p-t-64" }
const _hoisted_18 = { class: "flex-item-half-row flex-item-grow d-flex flex-col align-items-start m-t-32" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "m-b-24" }, "How it works", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-b-24" }, "It's quick and easy! Here are the steps:", -1))
const _hoisted_21 = { class: "d-flex align-items-center m-b-16" }
const _hoisted_22 = { class: "cmd-icon-container m-r-16" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 1 Download our app ")
const _hoisted_25 = { class: "d-flex align-items-center m-b-16" }
const _hoisted_26 = { class: "cmd-icon-container m-r-16" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 2 Connect with one of our doctors ")
const _hoisted_29 = { class: "d-flex align-items-center m-b-16" }
const _hoisted_30 = { class: "cmd-icon-container m-r-16" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 3 Receive your diagnosis and prescription ")
const _hoisted_33 = { class: "devices-container flex-item-half-row flex-item-grow justify-content-center align-items-center" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "app-download-container d-flex flex-col align-items-center p-t-64" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "logo icon-cmd" })
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Download the App!", -1))
const _hoisted_38 = { class: "download-links p-t-16" }
const _hoisted_39 = { class: "review-container d-flex flex-col align-items-center m-t-64" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "flex-item m-0 m-b-24 text-center" }, " Over 800 5 Star Reviews on Apple and Android ", -1))
const _hoisted_41 = { class: "review-wrapper" }
const _hoisted_42 = { class: "review-rating-1 flex-item-fill-row d-flex flex-row align-items-end" }
const _hoisted_43 = ["src"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "review-images flex-item-fill-row justify-content-center d-flex flex-row" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "how-can-we-help-container m-t-64 m-b-64" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLogo = _resolveComponent("HeaderLogo")!
  const _component_RouteButton = _resolveComponent("RouteButton")!
  const _component_SignupForm = _resolveComponent("SignupForm")!
  const _component_AppBadges = _resolveComponent("AppBadges")!
  const _component_HowCanWeHelpCard = _resolveComponent("HowCanWeHelpCard")!
  const _component_CorporateFooter = _resolveComponent("CorporateFooter")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, {
    contentWidthFull: "",
    contentHeaderPaddingDisabled: "",
    contentBodyPaddingDisabled: "",
    contentHeaderRemoveFalseHeaderSpace: "",
    contentBodyBottomMarginDisabled: "",
    backgroundImage: "",
    centerBackground: "",
    height: "856px"
  }, {
    background: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.backgroundImage,
        alt: "Signup Image"
      }, null, 8, _hoisted_1)
    ]),
    "content-header": _withCtx(() => []),
    "content-top": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_HeaderLogo, {
              "logo-light": "",
              "full-width": ""
            }, {
              left: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("img", { src: _ctx.telehealthImage }, null, 8, _hoisted_9)
            ]),
            _createVNode(_component_SignupForm, {
              "profile-controller": _ctx.profileController,
              "password-controller": _ctx.passwordController,
              "success-messages": _ctx.cloudMDSuccessMessages,
              "dark-style": "",
              "subscribe-cloudmd-marketing": "",
              onSuccess: _ctx.onSignupSuccess,
              class: "signup-form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RouteButton, {
                  pattern: _ctx.ButtonColorPattern.FILL,
                  color: _ctx.ButtonColor.PRIMARY,
                  route: _ctx.Route.Login.Home
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["pattern", "color", "route"])
              ]),
              _: 1
            }, 8, ["profile-controller", "password-controller", "success-messages", "onSuccess"])
          ])
        ])
      ])
    ]),
    "content-center": _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("img", { src: _ctx.featuredInImage }, null, 8, _hoisted_16)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    src: _ctx.iconPhone,
                    alt: "App Download"
                  }, null, 8, _hoisted_23)
                ]),
                _hoisted_24
              ]),
              _createElementVNode("li", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: _ctx.iconScope,
                    alt: "Connect with a provider"
                  }, null, 8, _hoisted_27)
                ]),
                _hoisted_28
              ]),
              _createElementVNode("li", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    src: _ctx.iconDoc,
                    alt: "Telehealth Appointments"
                  }, null, 8, _hoisted_31)
                ]),
                _hoisted_32
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("img", {
              src: _ctx.device2,
              alt: "Workflow"
            }, null, 8, _hoisted_34)
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _hoisted_37,
          _createElementVNode("p", null, _toDisplayString(_ctx.downloadText), 1),
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_AppBadges)
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("img", {
                src: _ctx.reviewRating1,
                class: "rating m-l-8 m-r-8 m-t-8"
              }, null, 8, _hoisted_43),
              _createElementVNode("img", {
                src: _ctx.reviewRating2,
                class: "stars m-l-8 m-r-8 m-t-8"
              }, null, 8, _hoisted_44)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("img", {
                src: _ctx.reviewImage1,
                class: "m-t-8 m-l-8 m-r-8"
              }, null, 8, _hoisted_46),
              _createElementVNode("img", {
                src: _ctx.reviewImage2,
                class: "m-t-8 m-l-8 m-r-8"
              }, null, 8, _hoisted_47),
              _createElementVNode("img", {
                src: _ctx.reviewImage3,
                class: "m-t-8 m-l-8 m-r-8"
              }, null, 8, _hoisted_48)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_HowCanWeHelpCard, { class: "flex-item-fill-row" })
          ])
        ])
      ])
    ]),
    "content-bottom": _withCtx(() => [
      _createVNode(_component_CorporateFooter, {
        branded: "",
        "brand-grey-bg": ""
      })
    ]),
    _: 1
  }))
}